var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.640234 14.8205C0.639531 17.341 1.30328 19.8022 2.56539 21.9715L0.519531 29.3834L8.16391 27.3945C10.2782 28.5366 12.6472 29.1351 15.0545 29.1352H15.0609C23.0079 29.1352 29.477 22.7186 29.4804 14.8317C29.482 11.01 27.9834 7.41627 25.2606 4.71255C22.5384 2.00907 18.9179 0.519414 15.0603 0.51767C7.11227 0.51767 0.643633 6.93395 0.640352 14.8205",
    fill: "url(#paint0_linear_79_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.874609 14.8158C-0.87543 17.4271 -0.187891 19.9763 1.11922 22.2233L-1 29.9008L6.91848 27.8407C9.10027 29.021 11.5568 29.6434 14.0564 29.6443H14.0628C22.295 29.6443 28.9965 22.9969 29 14.8277C29.0014 10.8686 27.4489 7.1457 24.6289 4.34512C21.8086 1.54488 18.0586 0.00162791 14.0628 0C5.82922 0 -0.871328 6.64651 -0.874609 14.8158ZM3.84113 21.8363L3.54547 21.3706C2.30258 19.4097 1.64656 17.1436 1.6475 14.8167C1.65008 8.02663 7.2193 2.50233 14.0675 2.50233C17.3839 2.50372 20.5006 3.78651 22.8448 6.11395C25.1889 8.44163 26.4788 11.5358 26.478 14.8267C26.475 21.6169 20.9056 27.1419 14.0628 27.1419H14.0579C11.8298 27.1407 9.64461 26.547 7.73891 25.425L7.28539 25.1581L2.58641 26.3806L3.84113 21.8363Z",
    fill: "url(#paint1_linear_79_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3293 8.62186C11.0497 8.00523 10.7554 7.99279 10.4895 7.98197C10.2718 7.97267 10.0229 7.97337 9.77422 7.97337C9.52531 7.97337 9.1209 8.06628 8.77906 8.43663C8.43687 8.80732 7.47266 9.70314 7.47266 11.5251C7.47266 13.3472 8.81012 15.108 8.99656 15.3553C9.18324 15.6022 11.5786 19.4608 15.3721 20.9452C18.525 22.1788 19.1666 21.9335 19.8508 21.8716C20.5352 21.81 22.0591 20.976 22.37 20.1113C22.6811 19.2466 22.6811 18.5055 22.5879 18.3506C22.4946 18.1963 22.2457 18.1036 21.8724 17.9185C21.4991 17.7333 19.6641 16.8373 19.3221 16.7137C18.9799 16.5902 18.7311 16.5286 18.4822 16.8994C18.2333 17.2696 17.5186 18.1036 17.3007 18.3506C17.0831 18.5981 16.8652 18.629 16.4921 18.4437C16.1186 18.2579 14.9166 17.8673 13.4906 16.6058C12.3811 15.6242 11.632 14.412 11.4143 14.0412C11.1965 13.6709 11.3909 13.4702 11.5781 13.2857C11.7458 13.1198 11.9514 12.8533 12.1382 12.6371C12.3243 12.4208 12.3864 12.2665 12.5109 12.0195C12.6355 11.7723 12.5731 11.556 12.48 11.3708C12.3864 11.1856 11.6612 9.35407 11.3293 8.62186Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_58",
    x1: 1448.56,
    y1: 2887.09,
    x2: 1448.56,
    y2: 0.51767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_58",
    x1: 1499,
    y1: 2990.08,
    x2: 1499,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.47f9641526de68b468236a93a4d89c07.svg";
export { ForwardRef as ReactComponent };